// Generat automat din README.md - Global Keyboard Shortcuts System
import React, { useEffect, useCallback, useState } from 'react';

export const useKeyboardShortcuts = (shortcuts = []) => {
  const handleKeyPress = useCallback((event) => {
    const key = event.key.toLowerCase();
    const ctrlKey = event.ctrlKey || event.metaKey; // Support both Ctrl and Cmd
    const shiftKey = event.shiftKey;
    const altKey = event.altKey;

    shortcuts.forEach(({ 
      key: shortcutKey, 
      ctrl = false, 
      shift = false, 
      alt = false, 
      action, 
      preventDefault = true,
      description 
    }) => {
      if (
        key === shortcutKey.toLowerCase() &&
        !!ctrl === ctrlKey &&
        !!shift === shiftKey &&
        !!alt === altKey
      ) {
        if (preventDefault) {
          event.preventDefault();
        }
        action(event);
      }
    });
  }, [shortcuts]);

  useEffect(() => {
    document.addEventListener('keydown', handleKeyPress);
    return () => document.removeEventListener('keydown', handleKeyPress);
  }, [handleKeyPress]);
};

// Global shortcut definitions
export const globalShortcuts = {
  // Navigation
  DASHBOARD: { key: 'h', ctrl: true, description: 'Mergi la Dashboard' },
  SEARCH: { key: 'k', ctrl: true, description: 'Deschide Căutare Globală' },
  
  // Actions
  NEW: { key: 'n', ctrl: true, description: 'Creează Nou' },
  SAVE: { key: 's', ctrl: true, description: 'Salvează' },
  REFRESH: { key: 'r', ctrl: true, description: 'Reîmprospătează' },
  
  // UI
  SIDEBAR_TOGGLE: { key: 'b', ctrl: true, description: 'Toggle Sidebar' },
  THEME_TOGGLE: { key: 't', ctrl: true, description: 'Schimbă Tema' },
  ESCAPE: { key: 'Escape', description: 'Închide Modal/Anulează' },
  
  // Export
  EXPORT: { key: 'e', ctrl: true, description: 'Export Date' },
  
  // Help
  HELP: { key: '?', shift: true, description: 'Afișează Ajutor' }
};

// Hook for managing shortcut help modal
export const useShortcutHelp = () => {
  const [showHelp, setShowHelp] = useState(false);

  const shortcuts = [
    { keys: 'Ctrl + H', description: 'Mergi la Dashboard' },
    { keys: 'Ctrl + K', description: 'Căutare Globală' },
    { keys: 'Ctrl + N', description: 'Creează Nou' },
    { keys: 'Ctrl + S', description: 'Salvează' },
    { keys: 'Ctrl + R', description: 'Reîmprospătează' },
    { keys: 'Ctrl + B', description: 'Toggle Sidebar' },
    { keys: 'Ctrl + T', description: 'Schimbă Tema' },
    { keys: 'Ctrl + E', description: 'Export Date' },
    { keys: 'Escape', description: 'Închide Modal' },
    { keys: 'Shift + ?', description: 'Afișează acest Ajutor' }
  ];

  return {
    showHelp,
    setShowHelp,
    shortcuts
  };
};